module.exports = __webpack_public_path__ + "img/icon-location.c515e144.svg";